{
  "CommonWebUI_Eula": "Conditions d'utilisation et<br>Politique de confidentialité",
  "CommonWebUI_Filters": "Filtres",
  "CommonWebUI_Logout": "Se déconnecter",
  "CommonWebUI_Profile": "Profil",
  "CommonWebUI_Help": "Aide",
  "CommonWebUI_Settings": "Réglages",
  "CommonWebUI_Satisfaction_Survey": "Sondage de satisfaction",
  "CommonWebUI_Zoom": "Zoom",
  "CommonWebUI_Theme": "Thème",
  "CommonWebUI_Theme_Auto": "Auto",
  "CommonWebUI_Theme_Dark": "Sombre",
  "CommonWebUI_Theme_Light": "Clair",
  "CommonWebUI_ChipslistInput_Search_Add": "Ajouter...",
  "CommonWebUI_ChipslistInput_Search_AddOrSelect": "Ajouter / sélectionner...",
  "CommonWebUI_DatePreset_Custom": "Personnalisé",
  "CommonWebUI_DatePreset_Today": "Aujourd'hui",
  "CommonWebUI_InputSearch_Placeholder": "Rechercher...",
  "CommonWebUI_InputText_Placeholder": "Entrez le texte ici...",
  "CommonWebUI_LayoutOperationStatus_Error": "Une erreur s'est produite. Veuillez réessayer",
  "CommonWebUI_LayoutOperationStatus_No_Data": "Pas de données",
  "CommonWebUI_Navigation_Menu": "Menu",
  "CommonWebUI_RichTextBox_CustomClass_Highlight": "Surligner",
  "CommonWebUI_RichTextBox_CustomClass_Note": "Note",
  "CommonWebUI_RichTextBox_CustomClass_Paragraph": "Paragraphe",
  "CommonWebUI_RichTextBox_CustomClass_Subtitle": "Sous-titre",
  "CommonWebUI_RichTextBox_CustomClass_Title": "Titre",
  "CommonWebUI_Select_Placeholder": "Veuillez sélectionner...",
  "CommonWebUI_No_Selection": "0 sélection",
  "CommonWebUI_Selection": "Sélection",
  "CommonWebUI_Selections": "Sélections",
  "CommonWebUI_Action_Save": "Sauvegarder",
  "CommonWebUI_Action_Add": "Ajouter",
  "CommonWebUI_Action_Clear": "Effacer",
  "CommonWebUI_Action_Ok": "Ok",
  "CommonWebUI_Action_Done": "Terminé",
  "CommonWebUI_Action_Cancel": "Annuler",
  "CommonWebUI_Action_Submit": "Soumettre"
}